import React from 'react';
import { ShieldCheck, Timer, Percent, MessageSquareHeart } from 'lucide-react';
import { Button } from '../components/ui/button';

const features = [
  { Icon: ShieldCheck, title: 'Vérification humaine', text: "Chaque cagnotte est examinée par notre équipe." },
  { Icon: Timer, title: 'Retrait rapide', text: 'Recevez vos fonds en 24-48h ouvrables.' },
  { Icon: Percent, title: '0% pour Yako', text: 'Aucun frais sur les cagnottes de solidarité.' },
  { Icon: MessageSquareHeart, title: 'Messages de soutien', text: 'Chaque donateur peut laisser un mot.' },
];

export default function TrustSection() {
  return (
    <section id="why" className="relative">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.18em] uppercase font-medium text-neutral-500">Pourquoi Fodindin</div>
            <h2 className="mt-2 text-[clamp(2rem,4vw,3.4rem)] leading-[1.05] font-semibold tracking-tight text-[#1a1d1a]">
              La confiance comme <span className="serif-italic text-[#5a8268]">fondation</span>.
            </h2>
            <p className="mt-5 text-[15px] text-neutral-600 max-w-md">
              Chaque cagnotte est vérifiée par notre équipe. Aucun frais caché. Transparence totale sur les transactions.
            </p>
            <Button className="mt-7 btn-anim rounded-full h-11 px-5 bg-[#1a1d1a] hover:bg-black text-white text-[14px] font-medium">Commencer maintenant</Button>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {features.map(({ Icon, title, text }) => (
              <div key={title} className="rounded-2xl bg-white border border-black/5 p-6 card-lift">
                <div className="w-10 h-10 rounded-xl bg-[#5a8268]/10 text-[#5a8268] flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-4 text-[16px] font-semibold text-[#1a1d1a]">{title}</h3>
                <p className="mt-1 text-[13.5px] text-neutral-600">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
